
import styled from 'styled-components'
import config from '../../config'

export const Container = styled.div`
position: relative;
top:0px;
left:0px;
width:100%;
height:100%;
`

export const MyNavBarContainer = styled.div`
position: fixed;
left: 0px;
top: 0px;
width: 100%;
padding-bottom: 2%;
.rdsbottom{
    border-bottom-left-radius: 40px;
}
z-index: 2;
`

export const MiddleContainer = styled.div`
overflow:scroll;
background-color:white;
padding-top:1px;
width:90%;
margin-left:5%;
margin-right:5%;
height:100%;
`
export const MiddleContextContainer = styled.div`
width: 90%;
margin-left: 5%;
margin-right: 5%;
margin-top: 25%;
.bd6aa8f5{
    border:1px solid #6aa8f5;
}
`

export const PatientInformation = styled.div`
width:78%;
margin-left:15%;
margin-top:4%;
`
export const ListItem = styled.div`
display:flex;
width:100%;
justify-content :space-between;
`
export const AdviceFood = styled.div`
display: flex;
flex-direction: row-reverse;

`
export const StyleContainer = styled.div`

`
export const BottomLine = styled.div`
width:106%;
border-top: solid rgb(204,201,201) 1px;
margin:${window.screen.height < 600 ? '3%' : '5%'};
margin-left: -6%;
}
`
// @media screen and (min-height: 750px) {
//     export const BottomLine = styled.div`
// width:106%;
// border-top: solid rgb(204,201,201) 1px;
// margin: 5%;
// margin-left: -6%;
// `
// }

export const OrdererInformation = styled.div`
width: 90%;
margin-left: 5%;
margin-right: 5%;
.phoneNumber{
    margin-top: 8%;
}
`

export const MySelectContainer = styled.div`
width:70px;
display:flex;
justify-content:center;
align-items:center;
padding-top:0px;
border: solid rgb(204,201,201) 1px;
border-radius:25px;
background: url("../../images/下拉.png") no-repeat scroll 80% center transparent !important;
`

export const MySelect = styled.select`
width:100%;
height: 1rem;
border: 1px solid #E6E6E6 !important;
border-radius: 20px !important;
appearance: none !important;
background-size: 20% !important;
padding-right: 30% !important;
padding-left:  5% !important;
`
export const BottomLiness = styled.div`
width:106%;
border-top: solid rgb(204,201,201) 1px;
margin: 1%;
margin-left: -6%;
`
export const Spinner = styled.div`
border-top-left-radius: 10%;
border-top-right-radius: 10%;
background-color: #efefef;
top: 66%;
left: 0%;
right: 0%;
bottom: 0%;
z-index: 1;
&&.shadow{
    box-shadow: 0px -6px 60px #888888;
}
.fontStyle{
    font-family: YouYuan;
    font-size:  1.5rem;
    color: #898989;
}
.line{
    width: 100%;
    border-top: solid rgb(204,201,201) 1px;
    margin: 1%;
    margin-left: 0%;
}
}
`

export const TelephoneServiceContainer = styled.div`
height: auto;
display: flex;
padding-left: 10px;
padding-top: 15px;
padding-bottom: 15px;
`
export const IconContainer = styled.div`
flex: 1;
display: flex;
justify-content: center;
`

export const TelephoneTextContainer = styled.div`
  font-family: 'YouYuan';
  font-size: 1rem;
  color: ${config.theme.textColor};
  flex: 5;
`
export const ContainerMiddleList = styled.div`

width:90%;
margin-left:5%;
margin-right:5%;
`
